import React from 'react';
import { Navigate } from 'react-router-dom';
import _ from 'lodash';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import Navigation from '../_components/Navigation';
import BookingForm from '../_components/bookingForm';
import { userService } from 'Services';

function BookingPage(props) {

    var privileges = null;

    if (props.authenticatedUser) {
        privileges = props.authenticatedUser.privileges;
    }

    var canAccessJobBooking = privileges && _.some(privileges, ['description', 'Job Booking']);

    if (!canAccessJobBooking)
        return <Navigate to="/Welcome" />

    return (
        <div>
            <Navigation active="booking" authenticatedUser={props.authenticatedUser} />
            <BookingForm authenticatedUser={props.authenticatedUser} />
        </div>
    );
}

const AuthenticatedBookingPage = withAuthenticatedUser(BookingPage);

export { AuthenticatedBookingPage as BookingPage };